<template>
  <van-popup v-model="show" position="right" :style="{ width: '100%', height: '100%' }" zIndex="9" :lock-scroll="false">
    <div class="hs-container-child" @click.stop>
      <c-header
          class="c-header-new"
          :title="title"
          leftIcon1="icons_24pt_back.png"
          :leftFn1="close"
      />

      <!-- 搜索框 -->
      <hs-search-bar-new
          className="style2"
          v-model="KeyWord"
          :placeholder="$t('Search_1')"
          :hasClear="!!KeyWord"
          @clear="KeyWord = ''"
      />

      <div class="hs-index-bar" v-if="indexList && !KeyWord">
        <div class="index" v-for="(item, index) in indexList" :key="index" @click="selectIndexList(item)">{{item}}</div>
      </div>

      <hs-scroll ref="tableView" :data="datalist" class="tableView">
        <ul>
          <template v-if="KeyWord || type === HOTEL_CARD_TYPE">
            <hs-null
                v-if="noValue(JSON.stringify(searchList))"
                style="padding-top: calc(38dvh - 88px)"
                styleType="empty"
                :title="$t('NoDataContent')"
            />
            <airline-list-item
                :details="{AirLines: searchList}"
                :key="`search`"
                @select="_select"
            />
            <hs-all-load-text v-if="searchList.length" />
          </template>
          <template v-else>
            <template v-if="datalist && datalist.length">
              <airline-list-item
                  v-for="(item, index) in datalist"
                  :details="item"
                  :key="`city${index}`"
                  @select="_select"
              />
            </template>
          </template>
          <div style="height: 50px"></div>
        </ul>
      </hs-scroll>
    </div>
  </van-popup>
</template>
<script type="text/ecmascript-6">
import CHeader from 'components/c-header/c-header'
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsSection from 'base/hs-tableview/hs-section/hs-section'
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import HsSearchBar from 'base/hs-search-bar/hs-search-bar'
import HsNull from 'base/hs-null/hs-null'
import {kpiFlightGetAllAirLines, kpiSystemInfoGetHotelGroups} from 'api'
import HsAllLoadText from "@/base/hs-null/hs-all-load-text.vue";
import HsSearchBarNew from "@/base/hs-search-bar/hs-search-bar-new.vue";
import HsNationItem from "@/base/hs-nation/hs-nation-item.vue";
import AirlineListItem from "@/pages/personal/passengers/card/airline-list-item.vue";
const HOTEL_CARD_TYPE = 'HotelCard'
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      HOTEL_CARD_TYPE,
      tableViewOptions: {
        pullDownRefresh: {
          threshold: 50
        },
        pullUpLoad: false
      },
      show: false,
      datalist: [],
      searchList: [],
      indexList: [],
      KeyWord: '',
      editingIndex: undefined
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.KeyWord = ''
        this.searchList = []
        this.indexList = []
        if (this.type === HOTEL_CARD_TYPE) {
          this._getHotelGroups()
        } else {
          this._getDatalist()
        }
      }
    },
    KeyWord() {
      if (this.type === HOTEL_CARD_TYPE) {
        this._getHotelGroupsSearchList()
      } else {
        this._getSearchList()
      }
    }
  },
  computed: {
    title() {
      let val = this.type === HOTEL_CARD_TYPE ? this.$t('HotelGroupMembership') : this.$t('Airline')
      return this.$t('Choose_x', 'function', [val])
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
      this.editingIndex = undefined
    },

    _getDatalist() {
      kpiFlightGetAllAirLines().then((res) => {
        console.log('航司列表: ', res)
        this.datalist = res.ResultData || []
        this.indexList = (this.datalist || []).map(v => v.Label)
      })
    },

    /** 获取酒店集团 */
    _getHotelGroups() {
      kpiSystemInfoGetHotelGroups().then(res => {
        this.datalist = res.ResultData
        this._getHotelGroupsSearchList()
      })
    },

    _select(item) {
      this.$emit('select', item, this.editingIndex)
      this.close()
    },

    _getSearchList() {
      let list = []
      this.datalist.map((v, index) => {
        if (index > 0) {
          list = list.concat(v.AirLines || [])
        }
      })
      this.searchList = list.filter(v => {
        return this._getIsIncludes(v)
      })
    },

    // 获取当前项是否匹配
    _getIsIncludes(v) {
      if (this.KeyWord && v) {
        let {AirLineCode, AirLineName, AirLineName_EN, Abbreviation} = v
        AirLineCode = AirLineCode ? AirLineCode.toLocaleLowerCase() : AirLineCode
        AirLineName = AirLineName ? AirLineName.toLocaleLowerCase() : AirLineName
        AirLineName_EN = AirLineName_EN ? AirLineName_EN.toLocaleLowerCase() : AirLineName_EN
        Abbreviation = Abbreviation ? Abbreviation.toLocaleLowerCase() : Abbreviation
        let KeyWord = this.KeyWord.toLocaleLowerCase()
        return (AirLineCode && AirLineCode.includes(KeyWord)) ||
          (AirLineName && AirLineName.includes(KeyWord)) ||
          (AirLineName_EN && AirLineName_EN.includes(KeyWord)) ||
          (Abbreviation && Abbreviation.includes(KeyWord))
      }
      return false
    },

    /** 酒店会员卡本地搜索 */
    _getHotelGroupsSearchList() {
      if (this.KeyWord) {
        this.searchList = this.datalist.filter(v => {
          return this._getHotelIsIncludes(v)
        })
      } else {
        this.searchList = [...this.datalist]
      }
    },

    _getHotelIsIncludes(v) {
      if (this.KeyWord && v) {
        let {Name, Code, Name_EN} = v
        Name = Name ? Name.toLocaleLowerCase() : Name
        Code = Code ? Code.toLocaleLowerCase() : Code
        Name_EN = Name_EN ? Name_EN.toLocaleLowerCase() : Name_EN
        let KeyWord = this.KeyWord.toLocaleLowerCase()
        return (Name && Name.includes(KeyWord)) ||
          (Code && Code.includes(KeyWord)) ||
          (Name_EN && Name_EN.includes(KeyWord))
      }
      return true
    },

    /** 索引栏选中 滚动 */
    selectIndexList(index) {
      console.log(index)
      this.$refs.tableView && this.$refs.tableView.scrollToElement(`#letter${index}`, 300)
    },
  },
  components: {
    AirlineListItem,
    HsNationItem, HsSearchBarNew, HsAllLoadText,
    HsNull,
    CHeader,
    HsScroll,
    HsSection,
    HsCell1,
    HsSearchBar
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child{
  @extend .flex-column;
  @extend .flex-start;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: $color_white;
  z-index: 200;
  .c-header-new{
    flex-shrink: 0;
  }
  .hs-index-bar{
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: $color_theme_300;
    z-index: 1;
    >.index{
      @extend .flex-center;
      @extend .hs-font-overline-3;
      padding: 1px;
      min-width: 20px;
    }
  }
  .tableView {
    width: 100%;
    height: calc(100% - 48px - 56px);
    overflow: hidden;
  }
}
</style>
